import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.array.index-of.js";
// 获取当前运营系统的类型
export var getSysType = function getSysType() {
  var sys = 'unknown';

  if (navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
    sys = 'ios';
  } else if (navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Adr') > -1) {
    sys = 'android';
  }

  return sys;
};